import React from "react";

export default class HomeCard extends React.Component {
  render() {
    const {
      background,
      type,
      width,
      content,
      style,
      imageStyle,
      alt
    } = this.props;

    return (
      <div className="hero-element" style={{ width }}>
        {type === "color" ? (
          <div style={{ background, ...style }}>{content && content}</div>
        ) : (
          <a href="https://www.wholesolblendbar.com/s/order">
            <picture>
              <img src={background} width="100%" style={imageStyle} alt={alt} />
            </picture>
          </a>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeCard/HomeCard.jsx